export default __webpack_public_path__ + "static/media/cooling-tower(3).1eaaf162.jpg";